import {Constants} from '../constants/commonConstants'

/**
 * Get bulk promotion validation errors
 * @param {Object} validationResult - The validation result object
 * @param {number} validationResult.totalPromotions - Total number of promotions
 * @param {number} validationResult.validPromotions - Number of valid promotions
 * @param {number} validationResult.invalidPromotions - Number of invalid promotions
 * @param {string} validationResult.validationStatus - Validation status (VALID, INVALID, NO_DATA)
 * @param {string} validationResult.message - Summary message of validation results
 * @param {Array<Object>} validationResult.details - Array of validation details per promotion
 * @param {string} validationResult.details[].cdPromotion - Promotion code or "WORKBOOK_LEVEL_ERRORS"
 * @param {Array<string>} validationResult.details[].errors - Array of error messages
 * @returns {JSX.Element} Error display component
 */
export const getBulkPromotionErrors = validationResult => {
  if (!validationResult) {
    return Constants.ErrorForFileUpload
  }

  const {validPromotions, invalidPromotions, details, message} = validationResult

  const getSummaryMessage = () => {
    if (validPromotions > 0) {
      return `${validPromotions} promotion(s) can be uploaded. ${invalidPromotions} promotion(s) have errors.`
    } else {
      return message
    }
  }

  const detailsWithErrors = details?.filter(detail => detail.errors && detail.errors.length > 0)

  return (
    <div>
      <div className="$font-small-bold">{getSummaryMessage()}</div>
      {detailsWithErrors?.map((detail, index) => (
        <div key={index} className="mt-2">
          <strong>{detail.cdPromotion}</strong>
          <ul className="ml-4 mt-1 list-inside list-disc">
            {detail.errors?.map((error, errorIndex) => (
              <li key={errorIndex}>{error}</li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  )
}

export const VALIDATION_STATUS = {
  VALID: 'VALID',
  INVALID: 'INVALID',
  NO_DATA: 'NO_DATA',
}
